/* eslint-disable jsx-a11y/anchor-is-valid */
import * as Yup from "yup";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { axiosInstance } from "../../Axios/https";
import Swal from 'sweetalert2'
import Loader from "../Loader/Loader";

const LoginComponent = () => {
  const [loader , setLoader] = useState(false);
  const navigate = useNavigate();
  const initialValues = {
    email: "",
    password: "",
  };
  const initialSchema = Yup.object().shape({
    email: Yup.string().email().required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: initialSchema,
      onSubmit: (values) => {
        setLoader(true);
        const formData = new FormData();
        formData.append("login_identifier", values.email);
        formData.append("password", values.password);
        axiosInstance.post('client/login' , formData).then((res) => {
          if (res?.data?.status === true) {
            const json = JSON.stringify(res?.data?.data);
            localStorage.setItem("token", res?.data?.token);
            localStorage.setItem("data", json);
            Swal.fire({
              title: "Stolen",
              text: res?.data?.message ? res?.data?.message : "Login Successfully",
              icon: "success",
            });
            navigate("/");
            setLoader(false);
          } else {
            Swal.fire({
              title: "Stolen",
              text: res?.data?.message,
              icon: "error",
            });
            setLoader(false);
          }
        }).catch((err) => {
          console.log(err);
          Swal.fire({
            title: "Stolen",
            text: 'Approval is pending from admin',
            icon: "error",
          });
          setLoader(false);
        })
      },
    });

  return (
    <>
      <>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Login</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Login
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="login-section pt-120 pb-120">
          <div className="container">
            <div className="row d-flex justify-content-center g-4">
              <div className="col-xl-6 col-lg-8 col-md-10">
                <div
                  className="form-wrapper wow fadeInUp"
                  data-wow-duration="1.5s"
                  data-wow-delay=".2s"
                >
                  <div className="form-title">
                    <h3>Log In</h3>
                    <p>
                      New Member? <Link to={"/signup"}>signup here</Link>
                    </p>
                  </div>
                  <form className="w-100" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-inner">
                          <label>Enter Your Email *</label>
                          <input
                            type="email"
                            placeholder="Enter Your Email"
                            name="email"
                            onChange={handleChange}
                            value={values.email}
                            onBlur={handleBlur}
                          />
                          {errors.email && touched.email ? (
                            <span className="ms-2" style={{ color: "red" , fontSize : '16px' }}>
                              {errors.email}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-inner">
                          <label>Password *</label>
                          <input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Password"
                            onChange={handleChange}
                            value={values.password}
                            onBlur={handleBlur}
                          />
                          <i className="bi bi-eye-slash" id="togglePassword" />
                          {errors.password && touched.password ? (
                            <span className="ms-2" style={{ color: "red" , fontSize : '16px' }}>
                              {errors.password}
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-agreement form-inner d-flex justify-content-between flex-wrap">
                          <div className="form-group">
                            <input type="checkbox" id="html" />
                            <label htmlFor="html">
                              I agree to the <a href="#">Terms &amp; Policy</a>
                            </label>
                          </div>
                          <Link to={'/forgot'} className="forgot-pass">
                            Forgotten Password
                          </Link>
                        </div>
                      </div>
                    </div>
                    <button className="account-btn">
                      {loader ? <Loader /> : 'Log in'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    </>
  );
};

export default LoginComponent;
